import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { localize, getLocale, isEnglish } from '../../util/Localizer'
import Paper from '@material-ui/core/Paper'
import Card from '@material-ui/core/Card'
import MemberSelectRow from '../../widgets/SubmitAClaim/memberSelectRow'
import NoServerError from '../../widgets/SubmitAClaim/NoServerError'
import Loading from '../../widgets/Loading'

import LinkStyles from '../../styles/components/link'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import Tooltip from '../../controls/Tooltip'
import { withStyles } from '@material-ui/core/styles'
import Auth from '../../auth/Auth'

import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import classnames from 'classnames'

// redux
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { fetchMemberSummary } from '../../redux/actions/memberSummaryActions'
import { Colors } from '../../theme'

class MemberSelect extends Component {
  constructor () {
    super()
    this.chooseMember = this.chooseMember.bind(this)
    this.state = {
      member: null,
      patientId: null,
      cob: null,
      patient: null,
      dependentId: 0
    }
  }

  componentDidMount () {
    this.props.updateUrl('')
    this.props.setNext(null)
    this.props.setPercent(20)
    this.props.adjustScrollBar()
  }

  updateNext () {
    if (this.state.member !== null && this.state.cob !== null) {
      if (this.props.memberSummary.isHCSAAvailable === true) {
        this.props.setNext('claimType')
      } else {
        this.props.setNext('claimTypeBenefit')
      }
      let object = {
        ActivityNotes: null,
        CertificateNumber: Auth.certificateNumber,
        PolicyNumber: Auth.policyNumber,
        PatientId: `${this.state.member}`,
        DependentId: this.state.dependentId,
        Patient: `${this.state.patient}`,
        CertificateEmail: this.props.memberSummary.email,
        SchoolName: null,
        ImageContent: [],
        cob: this.state.cob === 'true',
        ClaimCommonInfo: {
          Language: getLocale(),
          PayFromHealthCareSpendingAccount: false,
          PendingClaim: false,
          HealthCareSpendingAccountTopUpInfo: null
        }
      }
      this.props.updateClaim(object)
    } else {
      this.props.setNext(null)
    }
  }
  chooseMember (m) {
    let patient = `${m.firstName} ${m.lastName}`
    // NOTE: a dependent will have a different property than the primary person, we need to use
    // this so we can submit a receipt
    let dependentId = m.depId || m.insuredDependentId
    this.setState({ dependentId, member: m.patientId, patientId: m.patientId, patient: patient }, () => this.updateNext())
  }

  render () {
    const { classes = {} } = this.props
    let link = isEnglish() ? 'http://clhia.uberflip.com/i/405145-a-guide-to-the-coordination-of-benefits/0?' : 'http://clhia.uberflip.com/i/200193-guide-sur-la-coordination-des-prestations/0?'

    if (this.props.memberError) {
      return (
        <Paper className='submitCard'>
          <Row start='xs'>
            <Col xs={12}>
              <h3>{localize('pages.SubmitAClaim.MemberSelection.Title')}</h3>
              <NoServerError error={this.props.memberError} retry={this.props.fetchMemberSummary} />
            </Col>
          </Row>
        </Paper>
      )
    }

    if (this.props.isLoading) {
      return (
        <Paper className='submitCard'>
          <Row start='xs'>
            <Col xs={12}>
              <h3>{localize('pages.SubmitAClaim.MemberSelection.Title')}</h3>
              <Loading />
            </Col>
          </Row>
        </Paper>
      )
    } else if (this.props.isLoading === false) {
      const self = this
      let m = this.props.memberSummary
      return (
        <Card className='submitCard'>
          <Row start='xs'>
            <Col xs={12}>
              <Row>
                <Col className='memberSelectionTooltipContainer'>
                  <h3>{localize('pages.SubmitAClaim.MemberSelection.Title')}</h3>
                </Col>
                <Col>
                  <Tooltip enterTouchDelay={0} leaveTouchDelay={3000} title={localize('pages.memberSummary.tooltip.dependentNotListedOrTerminated')} placement="right-end">
                    <IconButton className={classes.iconMargin} >
                      <Icon style={{ color: Colors.Palette.primaryTextColor }}>info</Icon>
                    </IconButton>
                  </Tooltip>
                </Col>
              </Row>
              {/* <p className='titledLabelTitle'>{localize('pages.SubmitAClaim.MemberSelection.ContactPlanAdministrator')}</p> */}
              <p className={classnames(classes.selectText)}>{localize('pages.SubmitAClaim.MemberSelection.select')}</p>
              <br />
              <MemberSelectRow member={m} onClick={(m) => this.chooseMember(m)} selectedMember={this.state.member} />
              {this.props.memberSummary.dependents
                ? this.props.memberSummary.dependents.map(function (d, i) {
                  return (
                    <MemberSelectRow member={d} key={i} onClick={(d) => self.chooseMember(d)} selectedMember={self.state.member} />
                  )
                }) : null}
              <br />
              <p>{localize('pages.SubmitAClaim.MemberSelection.SpouseOrDependentCoverageUnderAnotherPlan')}</p>
              <RadioGroup
                aria-label={localize('pages.SubmitAClaim.MemberSelection.SpouseOrDependentCoverageUnderAnotherPlan')}
                value={this.state.cob}
                onChange={(e, v) => this.setState({ cob: v }, this.updateNext)}
              >
                <FormControlLabel
                  value={'true'}
                  control={<Radio color={'primary'}/>}
                  label={localize('pages.SubmitAClaim.MemberSelection.SpouseOrDependentCoverageUnderAnotherPlan.Yes')}
                />
                <FormControlLabel
                  value={'false'}
                  control={<Radio color={'primary'}/>}
                  label={localize('pages.SubmitAClaim.MemberSelection.SpouseOrDependentCoverageUnderAnotherPlan.No')}
                />
              </RadioGroup>
              <br />
              <a className={classes.link} onClick={() => window.open(link)}>{localize('pages.SubmitAClaim.MemberSelection.CoordinationOfBenefitsLinkDescription')}</a>
            </Col>
          </Row>
        </Card>
      )
    } else {
      return (
        <Paper className='submitCard'>
          <Row start='xs'>
            <Col xs={12}>
              <h3>{localize('pages.Shared.UnknownError')}</h3>
            </Col>
          </Row>
        </Paper>
      )
    }
  }
}

function mapStateToProps (state, ownProps) {
  return {
    memberSummary: state.memberSummaryReducer.memberSummary,
    isLoading: state.memberSummaryReducer.isLoading,
    memberError: state.memberSummaryReducer.error
  }
}

const ConnectedMemberSelect = connect(mapStateToProps, { fetchMemberSummary })(injectIntl(MemberSelect))

const styles = {
  ...LinkStyles,
  iconMargin: {
    marginTop: 14
  },
  selectText: {
    margin: '15px 0px 10px 0px',
    fontWeight: 'bold'
  }

}

export default withStyles(styles)(ConnectedMemberSelect)



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/MemberSelect.js